import e, { memo as G, useCallback as H, useMemo as ue } from "react";
import { Link as w, useTheme as Z, Image as N, useBreakpointValue as ce, useMultiStyleConfig as ie, Flex as b, Box as oe, Text as de } from "@chakra-ui/react";
import "../../atoms/link/button-link.js";
import { MarkDownReader as $ } from "../../atoms/mark-down-reader/mark-down-reader.js";
import "@chakra-ui/system";
import { typographyBreakpoints as fe, getTypography as L } from "../../../utils/typographyUtils.js";
import { getRelAttributeAccordingToUrl as v } from "../../../utils/externalUrlChecker.js";
import { AnalyticsEventType as Ee } from "../../../types/analytics.enums.js";
import { isBrowser as xe } from "../../../utils/commonUtils.js";
import { Paragraph as he } from "../../atoms/paragraph/paragraph.js";
import "./headline-sdm.js";
import { Title as Y } from "./title.js";
const z = G(
  ({
    titleCta: t,
    alignment: p,
    headlineTypography: f,
    headingTag: m,
    headingColor: d,
    textDefault: E,
    headlineMarkdown: i,
    title: h,
    titleLinkClickHandler: s,
    isExternalTitle: o
  }) => t ? /* @__PURE__ */ e.createElement(
    Y,
    {
      alignment: p,
      responsiveTypography: f,
      headingTag: m,
      color: d ?? E
    },
    /* @__PURE__ */ e.createElement(
      w,
      {
        href: t == null ? void 0 : t.url,
        onClick: (u) => s(u, t),
        rel: o,
        _hover: { textDecoration: "none" },
        "data-testid": "header-title-link",
        color: d ?? E
      },
      i ? /* @__PURE__ */ e.createElement($, { markDown: i }) : h
    )
  ) : /* @__PURE__ */ e.createElement(
    Y,
    {
      alignment: p,
      responsiveTypography: f,
      headingTag: m,
      color: d ?? E
    },
    i ? /* @__PURE__ */ e.createElement($, { markDown: i }) : h
  )
), O = G(
  ({
    logoUrl: t,
    logoCta: p,
    logoAltText: f,
    logoClickHandler: m,
    isExternalLogo: d,
    headingColor: E,
    textDefault: i
  }) => {
    const h = Z(), { header: s, element: o } = h;
    return t ? p !== void 0 ? /* @__PURE__ */ e.createElement(
      w,
      {
        href: p == null ? void 0 : p.url,
        onClick: (u) => m == null ? void 0 : m(u, p),
        rel: d,
        _hover: { textDecoration: "none" },
        "data-testid": "header-logo-link",
        color: E ?? i
      },
      /* @__PURE__ */ e.createElement(
        N,
        {
          src: t,
          maxHeight: s == null ? void 0 : s.logoHeight,
          "data-testid": "header-logo",
          paddingRight: o == null ? void 0 : o.spacingMedium,
          alt: f || ""
        }
      )
    ) : /* @__PURE__ */ e.createElement(
      N,
      {
        src: t,
        maxHeight: s == null ? void 0 : s.logoHeight,
        "data-testid": "header-logo",
        paddingRight: o == null ? void 0 : o.spacingMedium,
        alt: f || ""
      }
    ) : null;
  }
), be = G(
  ({
    title: t,
    titleClickHandler: p,
    subTitle: f,
    link: m,
    alignment: d = "LEFT",
    paragraphLeftIcon: E,
    headlineSize: i = 3,
    paragraphStyle: h = "regular",
    linkBottom: s,
    logoUrl: o,
    logoCta: u,
    logoUrl2: V,
    logoAltText: k,
    logo2AltText: T,
    logoClickHandler: j,
    clickHandler: F,
    headingTag: B,
    paragraphSize: A,
    headingColor: P,
    paragraphColor: C,
    trackingFn: W,
    logoLayout: l = "column",
    paragraphMarkdown: q,
    headlineMarkdown: ee,
    sponsoredText: J,
    titleCta: x,
    styleOverride: K = {},
    ...re
  }) => {
    const se = ce(fe, {
      ssr: !xe(),
      fallback: "base"
    }) === "Mobile" && l === "row" ? "rowLayout" : null, g = ie("Headline", { variant: se }), D = Z(), {
      element: a,
      linkDefault: Q,
      action: n,
      linkUnderline: S,
      header: M,
      localTokens: I,
      sp04: me,
      text: { default: U },
      common: { common04Regular: te }
    } = D, R = {
      base: `mobile0${i}`,
      sm: `tablet0${i}`,
      lg: `desktop0${i}`
    }, ae = {
      mobile: L(R.base, D.headline),
      tablet: L(R.sm, D.headline),
      desktop: L(R.lg, D.headline)
    };
    ({
      ...g ? { ...g == null ? void 0 : g.container } : {},
      ...K
    });
    const _ = H(
      (c, r) => {
        c.preventDefault(), r && W && W(Ee.UI_ENGAGEMENT, {
          actionType: "click",
          callToActionElement: r
        });
      },
      []
    ), X = H(
      (c, r) => {
        _(c, r), F && (r != null && r.url) && F(r.url);
      },
      []
    ), ne = H(
      (c, r) => {
        _(c, r), p && (r != null && r.url) && p(r.url);
      },
      []
    ), pe = H(
      (c, r) => {
        _(c, r), j && (r != null && r.url) && j(r.url);
      },
      []
    ), y = ue(() => ({
      link: v(m == null ? void 0 : m.url),
      bottom: v(s == null ? void 0 : s.url),
      logo: v(u == null ? void 0 : u.url),
      title: v(x == null ? void 0 : x.url)
    }), [m == null ? void 0 : m.url, s == null ? void 0 : s.url, x == null ? void 0 : x.url, u == null ? void 0 : u.url]);
    return /* @__PURE__ */ e.createElement(
      b,
      {
        paddingBottom: me,
        flexDirection: "column",
        gap: a == null ? void 0 : a.spacingMedium,
        ...re
      },
      /* @__PURE__ */ e.createElement(b, { flexDirection: l }, /* @__PURE__ */ e.createElement(b, { flexWrap: "wrap" }, /* @__PURE__ */ e.createElement(
        O,
        {
          logoUrl: o,
          logoCta: u,
          logoAltText: k,
          logoClickHandler: pe,
          isExternalLogo: y.logo,
          headingColor: P,
          textDefault: U
        }
      ), V && /* @__PURE__ */ e.createElement(
        N,
        {
          src: V,
          maxHeight: M == null ? void 0 : M.logoHeight,
          "data-testid": "header-second-logo",
          paddingRight: a == null ? void 0 : a.spacingMedium,
          alt: T || ""
        }
      )), /* @__PURE__ */ e.createElement(
        b,
        {
          columnGap: I == null ? void 0 : I.carouselHeaderColumnGap,
          gap: a == null ? void 0 : a.spacingMedium,
          width: "100%",
          flexDirection: {
            base: l === "row" ? "column" : "row",
            sm: "row"
          },
          alignItems: {
            base: l === "row" ? "flex-start" : "center",
            sm: "center"
          },
          ...K
        },
        /* @__PURE__ */ e.createElement(b, { flex: "1", justifyContent: d, flexDirection: "column" }, /* @__PURE__ */ e.createElement(
          z,
          {
            titleCta: x,
            alignment: d,
            headlineTypography: ae,
            headingTag: B,
            headingColor: P,
            textDefault: U,
            headlineMarkdown: ee,
            title: t,
            titleLinkClickHandler: ne,
            isExternalTitle: y.title
          }
        ), J && /* @__PURE__ */ e.createElement(oe, null, /* @__PURE__ */ e.createElement(de, { ...te, pt: a == null ? void 0 : a.spacingMedium }, J))),
        m && /* @__PURE__ */ e.createElement(
          w,
          {
            _hover: { textDecoration: "none", color: n == null ? void 0 : n.primaryHover },
            "data-testid": "header-link",
            href: m.url,
            onClick: (c) => X(c, m),
            rel: y.link,
            textDecoration: S,
            color: n == null ? void 0 : n.primaryDefault,
            "aria-label": `${m.text} ${t}`,
            flexShrink: "0",
            ...Q
          },
          m.text
        )
      )),
      f && /* @__PURE__ */ e.createElement(
        he,
        {
          leftIcon: E,
          alignment: d.toLocaleLowerCase(),
          paragraphStyle: h,
          size: A,
          color: C
        },
        q ? /* @__PURE__ */ e.createElement($, { markDown: q }) : f
      ),
      s && /* @__PURE__ */ e.createElement(
        w,
        {
          href: s.url,
          onClick: (c) => X(c, s),
          rel: y.bottom,
          _hover: { textDecoration: "none", color: n == null ? void 0 : n.primaryHover },
          "data-testid": "bottom-link",
          textDecoration: S,
          color: n == null ? void 0 : n.primaryDefault,
          ...Q
        },
        s.text
      )
    );
  }
);
be.displayName = "Headline";
z.displayName = "HeadlineTitle";
O.displayName = "LogoImage";
export {
  be as Headline
};
